var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollaborateWithfieldteams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.485,
    height: 80,
    viewBox: "0 0 83.485 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Collaborate_With_field_teams",
    "data-name": "Collaborate With field teams",
    transform: "translate(-18.7 -23.3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M120.392,103.3H113.4V65.116H95.993v6.969H89V58.147h31.392ZM106.481,30.344a6.969,6.969,0,1,0,6.993,6.969A6.973,6.973,0,0,0,106.481,30.344Zm0,20.834a13.939,13.939,0,1,1,13.985-13.939A13.994,13.994,0,0,1,106.481,51.178Z",
    transform: "translate(-18.282 0)",
    fill: "#f48a21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mask_1_",
    d: "M43.068,92.92V85.951H63.881V92.92Zm26.739,9.416-4.888-4.893,7.925-7.933-7.925-7.933,4.888-4.893,12.888,12.9Zm-44.145.964H18.7V58.147H49.957V72.086H42.994V65.117H25.662Zm6.962-72.956a6.969,6.969,0,1,0,6.962,6.969A6.958,6.958,0,0,0,32.625,30.344Zm0,20.834A13.939,13.939,0,1,1,46.55,37.239,13.963,13.963,0,0,1,32.625,51.178Z",
    transform: "translate(0 0)",
    fill: "#12355f",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollaborateWithfieldteams);
export default __webpack_public_path__ + "static/media/Collaborate With field teams.b5200672a3e3951310f76a45bb657230.svg";
export { ForwardRef as ReactComponent };